<template>
  <div>
    <!-- Header -->
    <div
      v-if="!cid"
      class="m-1"
    >
      <b-row>
        <!-- Search -->
        <b-col
          cols="12"
          md="12"
          class="mb-1"
        >
          <b-form-input
            v-model="filteringData.q"
            class="d-inline-block "
            :placeholder="$t('common.search')"
            @keydown.enter.native="startSearch()"
          />
        </b-col>
        <!-- Status Filter -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('projects.filter-status-label')"
            label-for="statusFilter"
          >
            <div class="d-flex align-items-center justify-content-end">
              <v-select
                v-model="filteringData.status"
                :options="lookupOptions.statusOptions"
                class="w-100"
                multiple
                :placeholder="$t('projects.filter-status')"
                :reduce="val => val.label"
              />
            </div>
          </b-form-group>
        </b-col>

        <!-- Tags Filter -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('projects.filter-tags-label')"
            label-for="tagsFilter"
          >
            <div class="d-flex align-items-center justify-content-end">
              <tags-selector
                v-model="filteringData.tags"
                :invertable="true"
                :tags-options="lookupOptions.tagsOptions"
                :tags-colors="lookupOptions.tagsColors"
              />
            </div>
          </b-form-group>
        </b-col>

      </b-row>
      <b-row>
        <app-collapse class="w-100 no-shadow-card">
          <app-collapse-item title="#">
            <template #header>
              <span class="small font-weight-bold">{{ $t('donations.more-filters') }}</span>
            </template>
            <b-row>
              <!-- Project Type Filter -->
              <b-col
                v-if="isChildren === false"
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('projects.filter-project-type')"
                  label-for="projectTypeFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <v-select
                      v-model="filteringData.projectType"
                      :options="lookupOptions.projectTypeOptions"
                      class="w-100"
                      :placeholder="$t('projects.filter-project-type')"
                      :reduce="val => val.label"
                    />
                  </div>
                </b-form-group>
              </b-col>

              <b-col
                v-if="isChildren === false"
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('projects.project-year')"
                  label-for="project-year"
                >
                  <b-form-input
                    v-model="filteringData.projectYear"
                    :placeholder="$t('projects.project-year')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>
              <!-- <b-col
                v-if="isChildren === false"
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('projects.givers-year')"
                  label-for="givers-year"
                >
                  <b-form-input
                    v-model="filteringData.giversYear"
                    :placeholder="$t('projects.givers-year')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col> -->
              <b-col
                v-if="isChildren === false"
                cols="12"
                md="4"
                class="mt-2"
              >
                <b-form-checkbox
                  id="only-free-founds"
                  v-model="filteringData.onlyWithoutFounds"
                >
                  {{ $t('projects.filter-only-free-founds') }}
                </b-form-checkbox>
              </b-col>

              <!-- Nation Filter -->
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="$t('projects.filter-nations-label')"
                  label-for="nationsFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <tags-selector
                      v-model="filteringData.nation"
                      :invertable="true"
                      :tags-options="lookupOptions.nationsOptions"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col
                v-if="isChildren === false"
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="$t('projects.project-zone')"
                  label-for="zoneFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <tags-selector
                      v-model="filteringData.zone"
                      :invertable="true"
                      :tags-options="lookupOptions.zoneOptions"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <!-- Missions Filter -->
              <b-col
                v-if="isChildren === true"
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="$t('projects.filter-missions-label')"
                  label-for="missionsFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <v-select
                      v-model="filteringData.mission"
                      :options="lookupOptions.missionsOptions"
                      class="w-100"
                      :placeholder="$t('projects.filter-missions')"
                      :reduce="val => val.label"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <!-- Birth Year From/To Filter -->

              <b-col
                v-if="isChildren === true"
                cols="12"
                md="6"
                lg="6"
              >
                <b-form-group
                  :label="$t('donations.contributor-name')"
                  label-for="contributor-name"
                >

                  <b-input-group>
                    <b-form-input
                      disabled
                      :value="(filteringData.fcname ? filteringData.fcname : $t('donations.filter-contributor'))"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="outline-primary"
                        @click="searchContributors()"
                      >
                        <feather-icon icon="SearchIcon" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col
                v-if="isChildren === true"
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('projects.from-birthyear')"
                  label-for="from-birthyear"
                >
                  <b-form-input
                    v-model="filteringData.birthYearFrom"
                    :placeholder="$t('projects.birth-year')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="isChildren === true"
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('projects.to-birthyear')"
                  label-for="to-birthyear"
                >
                  <b-form-input
                    v-model="filteringData.birthYearTo"
                    :placeholder="$t('projects.birth-year')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="isChildren === null"
                cols="12"
                md="6"
                class="mt-1"
              >
                <b-form-group>
                  <b-form-radio-group
                    v-model="filteringData.isChildren"
                    :options="lookupOptions.isChildrenOptions"
                    name="radio-inline"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="isChildren === true"
                cols="12"
                md="6"
                class="mt-1"
              >
                <b-form-checkbox
                  id="exclude-children-over-18"
                  v-model="filteringData.excludeChildrenOver18"
                >
                  {{ $t('projects.filter-exclude-children-over-18') }}
                </b-form-checkbox>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="mt-1"
              >
                <b-form-checkbox
                  id="only-donations"
                  v-model="filteringData.onlyWithDonations"
                >
                  {{ $t('projects.filter-only-donations') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </app-collapse-item>
        </app-collapse>
      </b-row>

      <b-row>
        <b-button
          id="_buttonSearch"
          class="btn-block"
          variant="outline-primary"
          @click="startSearch()"
        >
          <span class="text-nowrap">{{ $t('common.search-button') }}</span>
        </b-button>
      </b-row>
    </div>
    <!-- Table -->
    <b-table
      id="_listTable"
      ref="refListTable"
      class="position-relative"
      :items="fetchItems"
      responsive
      striped
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text=" $t('common.no-matching')"
      :sort-desc.sync="isSortDirDesc"
      :tbody-tr-class="getTableRowClass"
    >

      <!-- Column: Project -->
      <template #cell(project)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-avatar
              button
              size="32"
              :variant="`outline-${data.item.cisoff ? 'muted' : (data.item.isChildren ? 'warning' :'success')}`"
              @click="goto(data.item)"
            >
              <feather-icon
                :class="`text-${data.item.cisoff ? 'muted' : (data.item.isChildren ? 'warning' :'success')}`"
                :icon="data.item.isChildren ? 'UserIcon' :'MapPinIcon'"
              />
            </b-avatar>
          </template>
          <b-link
            class="font-weight-bold d-block text-wrap"
            @click="goto(data.item)"
          >
            {{ data.item.projectName }}
          </b-link>
          <small v-if="data.item.isChildren && data.item.infos">{{ (data.item.infos.projectCode && prefix !== 'alls' ? data.item.infos.projectCode +' / ' : '') }}{{ (data.item.infos.schoolClass ? data.item.infos.schoolClass +' / ' : '') }}{{ (data.item.infos.gender === 'M' ? $t('common.gender-M') : (data.item.infos.gender === 'F' ? $t('common.gender-F') : '-')) }} </small>
          <small v-if="!data.item.isChildren && data.item.infos">{{ data.item.infos.projectType }}</small>
        </b-media>
      </template>
      <!-- Column: Status -->
      <template #cell(status)="data">
        <b-badge
          v-if="data.item.infos && data.item.infos.status"
          pill
          :variant="`light-${resolveStatusVariant(data.item.infos.status)}`"
          class="text-capitalize"
        >
          {{ data.item.infos.status }}
        </b-badge>
      </template>
      <!-- Column: Donations -->
      <template #cell(donations)="data">
        <span
          v-for="(donats, index) in data.item.donations"
          :key="index"
        >
          <span
            v-if="donats.isLinked"
            class="text-success"
            :title="$t('donations.is-linked')"
          ><feather-icon
            icon="LinkIcon"
          />&nbsp;</span>
          <small class="clearfix">{{ (donats.donations_amount ? `${formatCurrency(donats.donations_amount, donats.currency)}${donats.donations_distinct > 0 ? ` - ${donats.donations_distinct} SAD/prog.` : ''}` : '-') }}</small>
        </span>
      </template>
      <!-- Column: Givers -->
      <template #cell(givers)="data">
        <span
          v-for="(giver, index) in data.item.givers"
          :key="index"
        >
          <span
            v-if="giver.isLinked"
            class="text-success"
            :title="$t('donations.is-linked')"
          ><feather-icon
            icon="LinkIcon"
          />&nbsp;</span>
          <small class="clearfix">{{ (giver.givers_amount ? `${formatCurrency(giver.givers_amount, giver.currency)} ${giver.balanceAmount ? ' (' + formatCurrency(giver.balanceAmount, giver.balanceCurrency) + ')' : ''} - ${giver.givers_count} erog.` : '-') }}</small>
        </span>
      </template>
      <!-- Column: Tags -->
      <template #cell(tags)="data">
        <span
          v-for="tag in new Set(data.item.tags)"
          :key="tag"
        >
          <b-badge
            v-b-tooltip.hover
            class="mr-25"
            :title="tag"
            :style="{ 'background-color': resolveTagBackground(tag, lookupOptions.tagsColors) }"
            pill
          >&nbsp;<feather-icon
            v-if="resolveTagIcon(tag) !== null"
            :icon="resolveTagIcon(tag)"
          />&nbsp;</b-badge>
        </span>

        <span
          v-if="data.item.isLinked"
        >
          <b-badge
            v-b-tooltip.hover
            class="mr-25"
            variant="light-success"
            :title="$t('projects.linked')"
            pill
          >&nbsp;<feather-icon
            icon="LinkIcon"
          />&nbsp;</b-badge>
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-link
          v-if="!cid && !data.item.cisoff"
          v-b-tooltip.hover
          :title="$t('donations.add-new')"
          class="text-nowrap ml-1"
          :to="{ name: 'view-projects', query: { newDonation: true }, params: { id: data.item.pid } }"
        >
          <feather-icon
            icon="DollarSignIcon"
            class="cursor-pointer"
            size="16"
          />
        </b-link>
        <b-link
          v-if="cid"
          v-b-tooltip.hover
          :title="$t(`projects.hide-${data.item.cisoff ? 'on' : 'off'}`)"
          class="text-nowrap ml-1"
          :class="{ 'nocisoff': data.item.cisoff }"
          @click="hide(data.item.pid, (data.item.cisoff ? null : true))"
        >
          <feather-icon
            :icon="data.item.cisoff ? 'EyeIcon' : 'EyeOffIcon'"
            class="cursor-pointer"
            size="16"
          />
        </b-link>
      </template>

    </b-table>

    <table-paginator
      v-model="currentPage"
      :total-items="totalItems"
      :per-page="perPage"
      :local-items-count=" (refListTable && refListTable.localItems ? refListTable.localItems.length : 0) "
    />
    <exporter-modal ref="modalExporter" />
    <contributors-modal ref="contributorsModal" />
  </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-return-assign */
import {
  BRow, BCol, BFormInput, BBadge, BTable, BMedia, BAvatar, BInputGroup, BInputGroupAppend,
  BFormRadioGroup, BFormGroup, BFormCheckbox, VBTooltip, BLink, BButton,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from 'vue-select'
import axios from '@axios'
import { ref, watch } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import authService from '@/vue.auth.service'
import lookupsService from '@/vue.lookups.service'
import sessionService from '@/vue.session.service'
import ContributorsModal from '@/views/contributors/ContributorsModal.vue'
import TablePaginator from '../layouts/tables/TablePaginator.vue'
import TagsSelector from '../layouts/tables/TagsSelector.vue'
import ExporterModal from '../layouts/ExporterModal.vue'

import {
  resolveStatusVariant, avatarText, resolveAvatarVariant, formatDateHumanFriendly, formatAddress, formatCurrency, formatAge, formatAgeYear,
  resolveTagBackground, resolveTagIcon, download, throwError, isValidYear, scrollTo,
  swalCustomOptions, toastErrorOptions, decode,
} from '../layouts/layouts.utils'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BBadge,
    BTable,
    BMedia,
    BAvatar,
    vSelect,
    TagsSelector,
    BInputGroup,
    BInputGroupAppend,
    BFormRadioGroup,
    BFormCheckbox,
    BFormGroup,
    BLink,
    TablePaginator,
    ExporterModal,
    AppCollapse,
    AppCollapseItem,
    BButton,
    ContributorsModal,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    isChildren: {
      type: Boolean,
      default: null,
    },
    callback: {
      default: null,
    },
    cid: {
      required: false,
      default: null,
    },
  },
  computed: {
    // eslint-disable-next-line no-nested-ternary
    prefix() { return (this.isChildren !== null ? (this.isChildren === true ? 'sad' : 'projects') : 'alls') },
    tableColumns() {
      /* eslint-disable object-curly-newline */
      const columns = [{ key: 'project', label: i18n.t('projects.project-name'), sortable: true, tdClass: (!this.isChildren ? 'max-width-td' : ''), sortKey: 'projectName' }]
      if (this.prefix === 'sad') columns.push({ key: 'age', label: i18n.t('projects.birth-year'), tdClass: 'small', formatter: (value, key, item) => `${(item.birthYear ? `${item.birthYear} - ${item.infos.birthDate ? formatAge(item.infos.birthDate) : formatAgeYear(item.birthYear)} anni` : '')}`, sortable: true, sortKey: 'birthYear' })
      else if (this.prefix === 'projects') {
        columns.push({ key: 'projectCode', label: i18n.t('projects.project-code'), sortable: true, formatter: (value, key, item) => item.infos.projectCode })
        columns.push({ key: 'projectDate', label: i18n.t('projects.project-date'), sortable: true, formatter: (value, key, item) => formatDateHumanFriendly(item.infos.projectDate, false) })
      } else if (this.prefix === 'alls') {
        columns.push({ key: 'projectCode', label: i18n.t('projects.alls-code'), sortable: true, formatter: (value, key, item) => item.infos.projectCode })
      }

      columns.push.apply(columns, [
        { key: 'tags', label: i18n.t('projects.filter-tags-label') },
        { key: 'status', label: i18n.t('projects.filter-status-label') },
        { key: 'mission', label: i18n.t('projects.mission'), tdClass: 'small max-width-td', formatter: (value, key, item) => `${item.infos && item.infos.nation ? `${item.infos.nation} / ` : ''}${item.infos && item.infos.missionName ? item.infos.missionName : ''}`, sortable: true, sortKey: 'mission' },
      ])

      if (this.prefix === 'projects') {
        columns.push({ key: 'totalAmount', label: i18n.t('projects.total-amount'), tdClass: 'small', formatter: (value, key, item) => formatCurrency(item.infos.totalAmount, item.infos.totalCurrency) })
        columns.push({ key: 'givers', label: i18n.t('projects.givers') })
      }
      columns.push({ key: 'lastDonation', label: i18n.t('projects.last-donations'), sortable: true, formatter: (value, key, item) => formatDateHumanFriendly(item.lastDonation, false) })
      columns.push({ key: 'donations', label: i18n.t('projects.donations') })
      columns.push({ key: 'lastUpdate', label: i18n.t('common.last-update-short'), sortable: true, formatter: formatDateHumanFriendly })
      if (authService.isUserInRole('write') && !this.modal && this.isChildren) { columns.push({ key: 'actions', label: i18n.t('common.actions') }) }
      return columns
    },
  },
  async mounted() {
    await this.reload()
    // eslint-disable-next-line no-underscore-dangle
    if (!this._events.changedArea) {
      this.$root.$on('changedArea', () => {
        this.reload()
      })
    }
  },
  beforeDestroy() {
    this.$root.$off('changedArea')
  },
  methods: {
    async reload() {
      const currentArea = await authService.currentArea()
      if (currentArea !== null) {
        this.reloadArea(currentArea)
      }
    },
    async reloadArea(area) {
      this.refaid = null
      const { obsoletes } = area.settings
      const options = {
        missionsOptions: await lookupsService.getMaps('projects.missionName', area.aid, obsoletes),
        nationsOptions: await lookupsService.getMaps('nations', area.aid, obsoletes),
        statusOptions: await lookupsService.getMaps('projects.status', area.aid, obsoletes),
        projectTypeOptions: await lookupsService.getMaps('projects.projectType', area.aid, obsoletes),
        isChildrenOptions: lookupsService.getisChildrenOptions(),
        tagsOptions: await lookupsService.getMaps('projects.tags', area.aid, obsoletes),
        zoneOptions: lookupsService.getZoneOptions().map(p => ({ label: p })),
        tagsColors: area.settings.tags,
      }
      this.lookupOptions = options
      this.refaid = area.aid
      if (!this.cid) {
        const filters = sessionService.getValue(`projects#${this.prefix}.filters.${this.refaid}`)
        if (filters && filters !== null) { this.setFilters(filters) } else this.setFilters(null)
      }
      this.refetchData()
    },
    goto(item) {
      if (this.modal) {
        if (this.callback) this.callback(item)
      } else this.$router.push({ name: 'view-projects', params: { id: item.pid } })
    },
    expoort() {
      this.$refs.modalExporter.show(`projects#${this.isChildren ? 'sad' : 'project'}`, (columns, exporterName) => {
        const filters = this.fetchFilters()
        filters.columns = columns
        axios.post('/api/exports/projects', filters, { responseType: 'arraybuffer' })
          .then(response => {
            download(response, exporterName)
            this.$refs.modalExporter.cancel()
          })
          .catch(error => {
            throwError(error)
            this.$refs.modalExporter.cancel()
          })
      })
    },
    hide(pid, off) {
      this.$swal(swalCustomOptions('projects.hide-warning', 'projects.hide-warning2'))
        .then(async result => {
          if (result.value === true) {
            try {
              const didX = { cid: this.cid, pid, off }
              await axios.post('/api/record/hide.donations', didX,
                { params: { aid: this.refaid, rid: 0 } })
              this.refresh()
              this.$emit('on-project-hiden', didX)
            } catch (error) {
              const message = toastErrorOptions
              if (error.response) message.props.text = decode(error.response.data.error)
              this.$toast(message, { position: 'top-center' })
            }
          }
        })
    },
    refresh() {
      this.refetchData()
    },
    clearFilters() {
      if (!this.cid) sessionService.remove(`projects#${this.prefix}.filters.${this.refaid}`)
      this.reload()
    },
    startSearch() {
      this.refetchData(true)
      scrollTo('_buttonSearch')
    },
    searchContributors() {
      this.$refs.contributorsModal.show(item => {
        this.filteringData.fcid = item.cid
        this.filteringData.fcname = `${item.fullName} | ${item.infos ? formatAddress(item.infos.address, true) : formatAddress(item.address, true)}`
        this.$refs.contributorsModal.cancel()
        this.refetchData(true)
      })
    },
    getTableRowClass(item, type) {
      if (type === 'row' && item && item.cisoff) return 'row-cisoff'
      return null
    },
  },
  setup(props) {
    const refaid = ref(null)
    const refListTable = ref(null)
    const perPage = ref(15)
    const totalItems = ref(0)
    const currentPage = ref(1)
    const isReloading = ref(false)
    const sortBy = ref(null)
    const isSortDirDesc = ref(true)

    const filteringData = ref({})
    const lookupOptions = ref({})

    function fetchFilters() {
      const filter = {
        aid: refaid.value,
        params: {
          perPage: perPage.value,
          page: currentPage.value,
          // eslint-disable-next-line no-nested-ternary
          sortBy: sortBy.value ? sortBy.value : (props.cid ? 'lastDonation' : 'lastUpdate'),
          sortDesc: sortBy.value ? isSortDirDesc.value : true,
        },
        filters: filteringData.value,
      }
      if (props.cid) filter.filters.cid = props.cid
      if (props.isChildren !== null) { filter.filters.isChildren = (props.isChildren === true ? 1 : 0) }
      return filter
    }
    const refetchData = async resetPaging => {
      if (refaid.value !== null) {
        const filter = fetchFilters()
        if (resetPaging) {
          isReloading.value = true
          currentPage.value = 1
        }
        if (filter && ((filter.filters.birthYearFrom && !isValidYear(filter.filters.birthYearFrom))
         || (filter.filters.birthYearTo && !isValidYear(filter.filters.birthYearTo))
         || (filter.filters.projectYear && !isValidYear(filter.filters.projectYear))
         || (filter.filters.giversYear && !isValidYear(filter.filters.giversYear)))) { return }
        await refListTable.value.refresh()
        isReloading.value = false
      }
    }

    watch([currentPage, perPage], () => {
      if (!isReloading.value) refetchData()
    })

    function setFilters(filters) {
      isReloading.value = true
      filteringData.value = (filters ? filters.filters : { isChildren: null })
      // eslint-disable-next-line no-nested-ternary
      sortBy.value = (filters ? filters.params.sortBy : null)
      isSortDirDesc.value = (filters ? filters.params.sortDesc : true)
      perPage.value = (filters ? filters.params.perPage : 15)
      currentPage.value = (filters ? filters.params.page : 1)
    }
    function fetchItems(ctx, callback) {
      if (refaid.value == null) {
        totalItems.value = 0
        callback([])
      } else {
        const filters = fetchFilters()
        if (!props.cid) sessionService.setValue(`projects#${this.prefix}.filters.${this.refaid}`, filters)
        axios.post('/api/lists/projects', filters)
          .then(response => {
            const { items, total } = response.data
            callback(items)
            totalItems.value = total
          })
          .catch(error => { throwError(error); callback([]) })
      }
    }

    return {
      refaid,
      fetchItems,
      fetchFilters,
      setFilters,
      perPage,
      currentPage,
      totalItems,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      avatarText,
      formatAddress,
      formatAge,
      formatAgeYear,
      formatDateHumanFriendly,
      formatCurrency,
      resolveStatusVariant,
      resolveAvatarVariant,
      resolveTagBackground,
      resolveTagIcon,
      lookupOptions,
      filteringData,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.max-width-td {
  max-width: 610px;
}
</style>
